import { render, staticRenderFns } from "./pickup-points-form.vue?vue&type=template&id=dfbb6c98&"
import script from "./pickup-points-form.vue?vue&type=script&lang=js&"
export * from "./pickup-points-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports